import React from 'react'
import { l } from '@manychat/manyui'

export const TiktokWasSuccessfullyReloaded = () => {
  return <span>{l.translate('TikTok channel permissions successfully refreshed')}</span>
}
